import { Role } from "types/generated";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { ButtonIconProps } from "ds/components/ButtonIcon";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";

import { showDeleteConfirmation } from "../DeleteConfirmation";
import { showRoleEditDetailsDrawer } from "../EditDetailsDrawer";

type RoleActionsProps = {
  role: Pick<
    Role,
    "id" | "name" | "slug" | "isSystem" | "roleBindingsCount" | "description" | "actions"
  >;
  analyticsPage: AnalyticsPageOrganization;
  onDeleteSuccess?: () => void;
  refetchQueries: string[];
  size?: ButtonIconProps["size"];
  isSystem?: boolean;
  readOnly?: boolean;
};

const RoleActions = ({
  role,
  analyticsPage,
  onDeleteSuccess,
  size = "small",
  refetchQueries,
  readOnly,
}: RoleActionsProps) => {
  const roleUrl = `/settings/role/${role.id}`;

  return (
    <DropdownMenuEllipsis tooltip="Role actions" dotsSize={size}>
      {!role.isSystem && !readOnly && (
        <>
          <DropdownMenuItem
            analyticsPage={analyticsPage}
            analyticsTitle="Edit details clicked"
            onAction={() => showRoleEditDetailsDrawer({ role, analyticsPage, refetchQueries })}
          >
            Edit details
          </DropdownMenuItem>
          <DropdownMenuItem
            analyticsPage={analyticsPage}
            analyticsTitle="Add permissions clicked"
            href={`${roleUrl}/permissions/`}
          >
            Add permissions
          </DropdownMenuItem>
        </>
      )}
      <CopyFieldDropdownMenuItem title="Copy ID" value={role.id} />
      <CopyFieldDropdownMenuItem
        analyticsPage={analyticsPage}
        analyticsTitle="Copy slug clicked"
        title="Copy slug"
        value={role.slug}
      />
      {!role.isSystem && !readOnly && (
        <DropdownMenuItem
          analyticsPage={analyticsPage}
          danger
          analyticsTitle="Delete Role Clicked"
          analyticsProps={{
            roleName: role.name,
          }}
          onAction={() =>
            showDeleteConfirmation({
              id: role.id,
              name: role.name,
              roleBindingsCount: role.roleBindingsCount,
              successCallback: onDeleteSuccess,
            })
          }
        >
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default RoleActions;
